import { render, staticRenderFns } from "./SsoAuth.vue?vue&type=template&id=6e60d57c&scoped=true"
import script from "./SsoAuth.vue?vue&type=script&lang=ts"
export * from "./SsoAuth.vue?vue&type=script&lang=ts"
import style0 from "./SsoAuth.vue?vue&type=style&index=0&id=6e60d57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60d57c",
  null
  
)

export default component.exports